import React from 'react';
import { pillars } from '../data/pillars';
import { images } from '../data/business';
export function WhyInnova() {
  return <section id="about" className="scroll-mt-20 bg-mist py-20 lg:py-28" aria-labelledby="why-title" data-id="element-341" data-mp="1n88ejm5jj3hn">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8" data-id="element-342" data-mp="18k41oyt65m6s">
        <div data-id="element-343" data-mp="1dif9z53tfomw">
          <h2 id="why-title" className="section-title" data-id="element-344" data-mp="1dhvtztxq7abi">
            A Pool Renovation Team You Can Count On.
          </h2>
          <p className="mt-5 max-w-lg text-lg leading-relaxed text-ink/75" data-id="element-345" data-mp="zmbktq7su6ha">
            Innova Pools &amp; Systems is a local Orlando team focused on one thing: renovating and repairing the pools
            Central Florida families already have.
          </p>
          <img src={images.completed} alt="Renovated pool and spa with a new paver deck at a Central Florida home" className="mt-10 aspect-[4/3] w-full rounded-2xl object-cover" data-id="element-346" data-mp="ulnnynww2vf5" />
        </div>

        <ul className="divide-y divide-line self-center" data-id="element-347" data-mp="37pqwqp14tnxj">
          {pillars.map(({
          title,
          description,
          icon: Icon
        }) => <li key={title} className="flex gap-5 py-8 first:pt-0 last:pb-0" data-id="element-348" data-mp="32r5wiplvr493">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy text-accent" data-id="element-349" data-mp="3gi15e1wdplco">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-350" data-mp="3cfxk6ljwr2e7" />
              </span>
              <div data-id="element-351" data-mp="2oquzt5xw2vg0">
                <h3 className="font-display text-xl font-bold text-navy" data-id="element-352" data-mp="2oq36y2vofbtf">{title}</h3>
                <p className="mt-2 text-base leading-relaxed text-ink/75" data-id="element-353" data-mp="2js1onk62rgj0">{description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}